import { render, staticRenderFns } from "./VideoHelpLink.vue?vue&type=template&id=54bdcaa0"
import script from "./VideoHelpLink.vue?vue&type=script&lang=js"
export * from "./VideoHelpLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports